import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UpdatedObjectives } from 'src/app/models/Orders.model';

@Injectable({
  providedIn: 'root'
})

export class GoalDataService {
    
  private objectivesArray: UpdatedObjectives[] = [];
  private objectivesSubject = new BehaviorSubject<UpdatedObjectives[]>([]);

  objectives$ = this.objectivesSubject.asObservable();

  setObjectives(objectives: UpdatedObjectives[]) {
  this.objectivesArray = objectives;
  this.objectivesSubject.next(this.objectivesArray);
  localStorage.setItem('monthlyObjectives', JSON.stringify(objectives));
}

initObjectivesFromStorage() {
  const saved = localStorage.getItem('monthlyObjectives');
  if (saved) {
    const parsed: UpdatedObjectives[] = JSON.parse(saved);
    this.objectivesArray = parsed;
    this.objectivesSubject.next(parsed);
  }
}



  getObjectives(): UpdatedObjectives[] {
    return this.objectivesArray;
  }

 getMonthlyGoal(year: number, month: number): number {
  const monthName = this.monthNumberToName(month);
  const obj = this.objectivesArray.find(o => o.yearly_objective === year && o.correspondingMonth?.toLowerCase() === monthName);
  return obj ? obj.net_value : 0;
}

getDailyGoal(year: number, month: number, day: number): number {
  const monthName = this.monthNumberToName(month);
  const obj = this.objectivesArray.find(o => o.yearly_objective === year && o.correspondingMonth?.toLowerCase() === monthName);
  return obj ? obj.daily_objective : 0;
}

private monthNumberToName(month: number): string {
  const months = [
    'gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno',
    'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'
  ];
  return months[month];
}

}
